import crypto from 'crypto';

const sha256 = (message: any) => {
  // const encoder = new TextEncoder();
  // const data = encoder.encode(message);
  // const hash = window.crypto.subtle.digest('SHA-256', data);
  // return hash;
  // const hasher = new sha256Module.Hash();
  // hasher.update(message, 43);

  // const result = hasher.digest();
  // return result;
  return crypto.createHash('sha256').update(message).digest();
};
const base64URLEncode = (input: any): string => {
  return input.toString('base64').replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
  //return btoa(input);
};
const createCodeVerifier = () => {
  const arr = new Uint32Array(6);
  return Array.from(window.crypto.getRandomValues(arr))
    .map((i) => i.toString(16))
    .join('-');
};
const getKeyValueFromLocation = ({ location, keyName }) => {
  const split = location.toString().split('?');
  if (split.length < 2) {
    return null;
  }
  const pairs = split[1].split('&');
  for (const pair of pairs) {
    const [key, value] = pair.split('=');
    if (key === keyName) {
      return decodeURIComponent(value || '');
    }
  }
  return null;
};
const getVerifierState = ({ clientId, storage }) => {
  const key = getEncodedVerifierKey(clientId);
  const value = JSON.parse(storage.getItem(key));
  return value;
};
const hashed = (o) => {
  return Object.getOwnPropertyNames(o)
    .map((prop) => `${prop}=${encodeURIComponent(o[prop])}`)
    .join('&');
};
const getEncodedVerifierKey = (clientId: string): string => `encodedVerifier-${encodeURIComponent(clientId)}`;
const removeCodeFromLocation = () => {
  const [base, search] = window.location.href.split('?');
  if (!search) {
    return;
  }
  const newSearch = search
    .split('&')
    .map((param) => param.split('='))
    .filter(([key]) => key !== 'code')
    .map((keyAndVal) => keyAndVal.join('='))
    .join('&');
  window.history.replaceState(window.history.state, '', base + (newSearch.length ? `?${newSearch}` : ''));
};
const removeStateFromStorage = ({ clientId, storage }) => {
  const key = getEncodedVerifierKey(clientId);
  storage.removeItem(key);
};
export {
  sha256,
  base64URLEncode,
  createCodeVerifier,
  getKeyValueFromLocation,
  getEncodedVerifierKey,
  getVerifierState,
  hashed,
  removeCodeFromLocation,
  removeStateFromStorage,
};
// eslint-disable-next-line prettier/prettier
